import {
  Button,
  CircularProgress,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider";
type BaseButtonProps = {
  title: string;
  disabled?: boolean;
  loading?: boolean;
  type?: "submit" | "button" | "reset";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps<Theme>;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  variant?: "text" | "outlined" | "contained";
  width?: number | string;
  heigth?: number | string;
  fontSize?: number | string;
  iconSize?: number | string;
  iconColor?: string;
  href?: string;
};
export default function BaseButton(props: BaseButtonProps) {
  const {
    loading,
    disabled,
    title,
    type,
    sx,
    endIcon,
    startIcon,
    onClick,
    variant,
    width,
    heigth,
    fontSize,
    iconSize,
    iconColor,
    href,
  } = props;
  const { theme } = useContext(MainContext);
  const secondary = theme.muiTheme.palette.secondary.main;
  return (
    <Button
      href={href}
      disabled={loading || disabled}
      onClick={onClick}
      sx={{
        backgroundColor: "transparent",
        borderColor: secondary,
        color: "#22323D",
        "& .MuiTypography-root": {
          color: secondary,
          fontWeight: 600,
          fontSize: fontSize || "16px",
        },
        "& .MuiCircularProgress-root": {
          color: "#FFFFFF",
          padding: 1,
        },
        "& .MuiSvgIcon-root": {
          color: iconColor || secondary,
          width: iconSize || "20px",
          height: iconSize || "20px",
        },
        "&:hover": {
          borderColor: secondary,

          backgroundColor: secondary,
          color: "#22323D",
          "& .MuiTypography-root": {
            color: "#FFFFFF",
          },
          "& .MuiSvgIcon-root": {
            color: "#FFFFFF",
          },
        },
        borderRadius: "8px",
        height: heigth || "42px",
        width: width || "100%",
        shadow: "none",
        ...sx,
      }}
      variant={variant ?? "outlined"}
      type={type}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {loading ? <CircularProgress /> : <Typography>{title}</Typography>}
    </Button>
  );
}
